import { UsersIcon, FlagIcon, Link } from '@buffer-mono/popcorn'

import { ChannelAccountType } from '../../../../../types'

export const ACCOUNT_OPTIONS_FOR_CHANNELS = [
  {
    accountType: ChannelAccountType.page,
    header: 'Page',
    icon: <FlagIcon size="medium" color="subtle" />,
    description:
      'A page is for businesses, brands, organizations and public figures users "like" or "follow". Connecting to personal or professional profiles is not supported by Meta.',
  },
  {
    accountType: ChannelAccountType.group,
    header: 'Group',
    icon: <UsersIcon size="medium" color="subtle" />,
    description: (
      <>
        Share to Groups as a member or an admin. <br />
        Direct publishing to Facebook Groups is not supported by Meta. Buffer
        facilitates scheduling your posts with mobile-based notifications.{' '}
        <Link
          href="https://support.buffer.com/articles/connecting-and-publishing-to-your-facebook-group-with-buffer-VevqG0mHZG"
          external
        >
          Learn more
        </Link>
      </>
    ),
  },
]
